import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { createRef, Component } from 'react';
import { KeyboardKey } from 'constants/keyboard';
import { jsx as _jsx } from "react/jsx-runtime";
const LOWER_LIMIT = 0;
const TAB_INDEX = 0;

class ListNavigator extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      highlightedResultIndex: this.props.highlightedResultIndex
    });

    _defineProperty(this, "divRef", /*#__PURE__*/createRef());

    _defineProperty(this, "handleKeyNavigation", event => {
      const {
        itemCount,
        onSelect,
        onHighlightedResultChange
      } = this.props;
      const {
        highlightedResultIndex
      } = this.state;
      const {
        key
      } = event;
      const upperLimit = itemCount - 1;
      if (!itemCount) return;

      switch (key) {
        case KeyboardKey.ArrowDown:
          event.preventDefault();
          this.setHighlightedSearchResult((highlightedResultIndex !== null && highlightedResultIndex !== void 0 ? highlightedResultIndex : LOWER_LIMIT - 1) < upperLimit, 1, LOWER_LIMIT, onHighlightedResultChange);
          break;

        case KeyboardKey.ArrowUp:
          event.preventDefault();
          this.setHighlightedSearchResult((highlightedResultIndex !== null && highlightedResultIndex !== void 0 ? highlightedResultIndex : upperLimit + 1) > LOWER_LIMIT, -1, upperLimit, onHighlightedResultChange);
          break;

        case KeyboardKey.Enter:
          if (highlightedResultIndex === null) break;
          event.preventDefault();
          if (onSelect) onSelect(highlightedResultIndex, event);
          break;

        default:
          this.resetHighlightedResult();
      }
    });
  }

  focusResultsContainer() {
    const {
      current: resultsContainer
    } = this.divRef;
    if (!resultsContainer) return;
    resultsContainer.focus();
  }

  setHighlightedSearchResult(isValueInRange, modifier, nullModifier, callback) {
    if (isValueInRange) {
      this.setState(prevState => ({
        highlightedResultIndex: prevState.highlightedResultIndex === null ? nullModifier : prevState.highlightedResultIndex + modifier
      }), () => callback === null || callback === void 0 ? void 0 : callback(this.state.highlightedResultIndex));
    } else {
      this.resetHighlightedResult();
    }
  }

  resetHighlightedResult() {
    this.setState({
      highlightedResultIndex: null
    });
  }

  render() {
    const {
      isListeningToEvents
    } = this.props;
    const {
      highlightedResultIndex
    } = this.state;
    const renderChildrenWithProps = this.props.children({
      highlightedResultIndex,
      focusResultsContainer: this.focusResultsContainer,
      handleKeyNavigation: this.handleKeyNavigation
    });
    if (!isListeningToEvents) return renderChildrenWithProps;
    return /*#__PURE__*/_jsx("div", {
      ref: this.divRef,
      onKeyDown: this.handleKeyNavigation,
      tabIndex: TAB_INDEX,
      "data-testid": "list-navigator-container",
      children: renderChildrenWithProps
    });
  }

}

_defineProperty(ListNavigator, "defaultProps", {
  highlightedResultIndex: null,
  isListeningToEvents: false
});

export default ListNavigator;